module.exports = __webpack_public_path__ + "static/img/gaozhongshengwu3.aafc8efd.jpg";